module.exports = __webpack_public_path__ + "static/img/logo2.f6d7bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo2.png
// module id = SF2Q
// module chunks = 1